import React from 'react';

export default function FloorShadow() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-8 bottom-2 h-24 rounded-[100%] bg-[radial-gradient(ellipse_at_center,_rgba(255,213,79,0.22)_0%,_rgba(255,248,225,0.12)_48%,_transparent_78%)] blur-md"
    />
  );
}
